import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';
import type { Query } from '../op-types';

export function createImageQueries(client: StoxlyClient) {
  return createQueryKeys('images', {
    // ['images', 'logo', symbol, { query }]
    logo: (symbol: string, query?: Query<'imagesGetLogo'>) => ({
      queryKey: [symbol, { query }],
      queryFn: ({ signal }) => client.imagesGetLogo({ params: { symbol }, queries: query, signal }),
    }),
  });
}
